import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url: string = state.url;
        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
      if(this.authService.authKey != null) return true;
     
      // Navigate to the login page with extras
      this.router.navigate(['login']);
      return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts